export default class Range {
    up_to = 0
    price = 0
    min_order = 0
    free_fee = false
    old_price = '0'
    minDelivery = null
    maxDelivery = null

    constructor(up_to = 0, price = 0, min_order = 0, free_fee = false, old_price = '0', minDelivery = 0, maxDelivery = 0) {
        this.up_to = up_to
        this.price = price
        this.min_order = min_order
        this.free_fee = free_fee
        this.old_price = old_price
        this.minDelivery = minDelivery
        this.maxDelivery = maxDelivery
    }

}